import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { HeatingCircuitDetailsRow } from '../details-row';
import { DetailsLabel } from '../details-label';
import { getControlDevice } from 'console/shared/components/panels/heating-circuits/heating-circuit/components/status-line/utils/status-line';
import { useZ3KDeviceState } from 'console/shared/hooks/device/z3k';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { removeNulls } from 'utils';
export const ControlDevices = memo(function ControlDevices(props) {
    const { heating_circuit } = props;
    const { z3k_config } = useDeviceConfig();
    const z3k_state = useZ3KDeviceState();
    const circuit_control_devices = useMemo(() => heating_circuit.control_devices.map((id) => {
        const control_device = getControlDevice(id, z3k_config, z3k_state);
        if (!control_device) {
            return null;
        }
        const { name, status, icon } = control_device;
        return (_jsx(HeatingCircuitDetailsRow, { label: name, value: status, value_icon: icon }, id));
    }), [z3k_config, z3k_state, heating_circuit]);
    const control_devices = removeNulls(circuit_control_devices);
    const has_control_devices = control_devices.length > 0;
    if (!has_control_devices) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(DetailsLabel, { label: "\u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430" }), control_devices] }));
});
